import EmptyVehiclePlaceholder from './EmptyVehiclePlaceholder'

export default EmptyVehiclePlaceholder
